import { render, staticRenderFns } from "./TransferContractInfo.vue?vue&type=template&id=126f4080&"
import script from "./TransferContractInfo.vue?vue&type=script&lang=js&"
export * from "./TransferContractInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TransferContractInfo.vue"
export default component.exports